import React, { createContext } from 'react';

export interface ISearchContext {
  searchHandler: (stuff: any) => void;
  searchFunctionsHandler: (stuff: any) => void;
  clearSearch: null | (() => void) | undefined;
  setSearchValue?: null | ((val: string) => void);
}

export const SearchContext = createContext<ISearchContext>(null!);

export default function ({
  searchHandler,
  searchFunctionsHandler,
  clearSearch,
  setSearchValue,
  children,
}: ISearchContext & {
  children: JSX.Element;
}) {
  return (
    <SearchContext.Provider
      value={{
        searchHandler,
        searchFunctionsHandler,
        clearSearch,
        setSearchValue,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
}
